import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"


import globalMU from "globalMU"

export type DefinirRegimeEspecialItemParams = {
    identificadorItem: number,
    desativaRegimeEspecial: boolean,
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any
}

export async function definirRegimeEspecialItem(params: DefinirRegimeEspecialItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarRegimeEspecialItem(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem,
            params.desativaRegimeEspecial
        )

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)

    } finally {
        globalMU.unblockUI()
    }
}